<template>
    <div>
        <skeleton-loader type="detail" v-if="loading" />
        <div v-else>
            <routine-detail :routine="currentRoutine" @selectRoutine="onSelectRoutine" @updated="onUpdated" />
            <assign-routine-dialog ref="assign" :routine-id="routineId" :coach-id="coachId" />
        </div>
    </div>
</template>

<script>

import RoutineDetail from '@/components/coach/routines/RoutineDetail'
import {db} from '@/utils/Firebase'
import {mapState, mapMutations} from 'vuex'
import {getMergedBlocks} from "@/utils/Exercises";
import SkeletonLoader from "@/components/common/SkeletonLoader";
import AssignRoutineDialog from '../../components/coach/routines/AssignRoutineDialog.vue';

export default {
    components: {SkeletonLoader, RoutineDetail, AssignRoutineDialog},
    data() {
        return {
            loading: false,
            routine: null,
        }
    },
    computed: {
        ...mapState(['currentRoutine', 'libraryCoach']),
        routineId(vm = this) {
            return vm.$route.params.uid
        },
        coachId(vm = this) {
            return vm.isCompany ? vm.libraryCoach?.id || null : vm.currentUser?.uid || null
        }
    },
    methods: {
        ...mapMutations(['setCurrentRoutine']),
        async setRoutine() {
            const vm = this
            await vm.withLoading(async () => {
                let routineRef = await db.collection('routines').doc(vm.routineId).get()
                if (!routineRef.exists) {
                    vm.toast(vm.$t('common.error_generic'), 'error')
                    return vm.$router.back()
                }
                vm.routine = routineRef.data()
                vm.routine.blocks = await getMergedBlocks(vm.routine.blocks)
                vm.setCurrentRoutine(vm.routine)
            })
        },
        onUpdated(blocks) {
            const vm = this
            if (!Array.isArray(blocks)) return vm.setRoutine()
            vm.routine = { ...(vm.routine || vm.currentRoutine || {}), blocks }
            vm.setCurrentRoutine(vm.routine)
        },
        onSelectRoutine() {
            const vm = this
            vm.$refs.assign.show()
        },
    },
    mounted() {
        const vm = this
        vm.setRoutine()
    },
    beforeRouteLeave(to, from, next) {
        const vm = this
        if (!vm.dialogStack.length) vm.setCurrentRoutine(null)
        next()
    }
}
</script>

<style scoped>

</style>